import TrackerLink from 'scenes/Gallery/components/TrackerLink';
import React from 'react';

const metrics = [
  'ClicksUnique',
  'AccountCreatedUnique',
  'LandingPageLogInsUnique',
  'InstallStartedUnique',
  'ApplicationOpenedUnique',
  'AuthUnique',
  'UniqueDesktopRegistration',
  'cvr_unique',
  'FiveQuestComplete',
  'Day1R',
  'Day7R',
  'Depositors',
  'Deposits',
  'DepositAmountUsd',
  'TotalArpu',
  'TotalArppu',
  'SpentUsd',
  'ROITotal',
  'TotalRoasD7',
  'TotalRoasD30',
];
const chartMetrics = ['ClicksUnique', 'cvrSEP0SEPunique'];

const AdsLink = ({ id, dimension, children }) => {
  return (
    <TrackerLink
      id={id}
      dimension={dimension}
      metrics={metrics}
      chartMetrics={chartMetrics}
    >
      {children}
    </TrackerLink>
  );
};
export default AdsLink;
